export const staff = [
  {
    name: "Denise Arkell",
    title: "Executive Director",
  },
  {
    name: "Heather Moroz",
    title: "Manager of Administrative Services",
  },
  {
    name: "Krista D'Aoust",
    title: "Director of Community Food and Family Services",
  },
  {
    name: "Charlotte Redekop-Young ",
    title: "Manager of Emergency Food Services",
  },
  {
    name: "Deban Brunette",
    title: "Director of Educational Programs",
  },
  {
    name: "Marija Kupina",
    title: "Coordinator of Volunteers",
  },
  {
    name: "Robyn Knickle",
    title: "Director of Development",
  },
  {
    name: "Laura Ryan",
    title: "Manager of Family Services",
  },
  {
    name: "Amy Angelo",
    title: "Manager of Food Access and Skills",
  },
  {
    name: "Danielle Boissoneau",
    title: "Community Action Coordinator",
  },
  {
    name: "Mark Raymond",
    title: "Community Chef",
  },
  {
    name: "Narmin Mzouri",
    title: "Outreach Coordinator",
  },
  {
    name: "Shane Farraway",
    title: "Communications and Events Coordinator",
  },
]
